import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({ 
  title = 'SharePanda - Secure File Sharing & Distribution Platform',
  description = 'SharePanda is a powerful file distribution platform for developers and teams. Share APKs, IPAs, executables, and large files securely with API integration.',
  keywords = 'file sharing, file distribution, APK distribution, IPA sharing, secure file transfer, developer tools, API file upload, beta testing, mobile app distribution',
  url = 'https://sharepanda.org',
  image = 'https://sharepanda.org/og-image.png',
  type = 'website',
  author = 'SharePanda',
  jsonLd = null
}) {
  const fullTitle = title.includes('SharePanda') ? title : `${title} | SharePanda`;
  const canonicalUrl = url.endsWith('/') ? url.slice(0, -1) : url;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="SharePanda" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Structured Data - JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}

export default SEO;
